class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Dropdown (desktop) controls: Apply / Close buttons should just close the panel.
    const dropdown = this.querySelector('[data-facets-dropdown]');
    if (dropdown) {
      dropdown.querySelectorAll('[data-facets-dropdown-close], [data-facets-dropdown-apply]').forEach((btn) => {
        btn.addEventListener('click', () => {
          dropdown.removeAttribute('open');
        });
      });
    }
  }


  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    // document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');

    // Collection pages use `#CollectionProductGrid`.
    const currentCollectionGrid = document.getElementById('CollectionProductGrid');
    const nextCollectionGrid = parsed.getElementById('CollectionProductGrid');
    if (currentCollectionGrid && nextCollectionGrid) {
      currentCollectionGrid.innerHTML = nextCollectionGrid.innerHTML;

      // Only initialize Ajaxinate when the collection grid exists.
      if (document.querySelector('[data-ajaxinate-container]')) {
        new Ajaxinate({
          callback: () => {
            const countElement = document.getElementById('viewed-count');
            const loadedItems = document.querySelectorAll(
              '[data-ajaxinate-container] .grid__item:not(.promotion-banner-card):not([data-promo-tile])'
            ).length;
            if (countElement) countElement.textContent = loadedItems;
          }
        });
      }

      return;
    }

    // Search pages use `#ProductGridContainer` (and `#product-grid` inside it).
    const currentSearchGrid = document.getElementById('ProductGridContainer');
    const nextSearchGrid = parsed.getElementById('ProductGridContainer');
    if (currentSearchGrid && nextSearchGrid) {
      currentSearchGrid.innerHTML = nextSearchGrid.innerHTML;

      if (document.querySelector('[data-ajaxinate-container]')) {
        new Ajaxinate({
          callback: () => {
            const countElement = document.getElementById('viewed-count');
            const loadedItems = document.querySelectorAll(
              '[data-ajaxinate-container] .grid__item:not(.promotion-banner-card):not([data-promo-tile])'
            ).length;
            if (countElement) countElement.textContent = loadedItems;
          }
        });
      }
    }
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');

    // Prefer the mobile count source if present; otherwise fall back to desktop.
    const sourceEl =
      parsed.getElementById('ProductCount') ||
      parsed.getElementById('ProductCountDesktop');

    if (!sourceEl) return;

    const countHTML = sourceEl.innerHTML;

    // Update all instances (theme currently renders ProductCountDesktop in multiple places).
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((el) => {
      el.innerHTML = countHTML;
      el.classList.remove('loading');
    });
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const mobileDrawer = mobileForm ? mobileForm.closest('menu-drawer') : null;
    if (mobileDrawer && typeof mobileDrawer.bindEvents === 'function') {
      mobileDrawer.bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const collectionGrid = document.getElementById('main-collection-product-grid');
    if (collectionGrid?.dataset?.id) {
      return [{ section: collectionGrid.dataset.id }];
    }

    // Search template: the filters aside carries the section `data-id`.
    const searchFilters = document.getElementById('main-search-filters');
    if (searchFilters?.dataset?.id) {
      return [{ section: searchFilters.dataset.id }];
    }

    // Fallback: search results wrapper also has `data-id`.
    const searchGrid = document.getElementById('product-grid');
    if (searchGrid?.dataset?.id) {
      return [{ section: searchGrid.dataset.id }];
    }

    return [];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    if(window.innerWidth <= 1109) {
      let sortByMobile = document.getElementById('SortBy-mobile')?.value;
      if(sortByMobile) {
        formData.set('sort_by', sortByMobile);
      }
    }
    const searchParams = new URLSearchParams(formData).toString();

    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Mobile sorting select is rendered outside the drawer; handle it here.
document.addEventListener('change', (event) => {
  const target = event.target;
  if (!target || target.id !== 'SortBy-mobile') return;
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', target.value);
  FacetFiltersForm.renderPage(url.searchParams.toString(), event);
});

// Close mobile facets drawer from header "X"
document.addEventListener('click', (event) => {
  const closeEl = event.target.closest('[data-mobile-facets-close]');
  if (!closeEl) return;
  event.preventDefault();

  const drawer = closeEl.closest('menu-drawer');
  const summary = drawer?.querySelector('details.mobile-facets__disclosure > summary');
  if (summary) summary.click();
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
